/* eslint-disable react/prop-types */ // TODO: add props
import { forwardRef } from 'react';
import cx from 'classnames';
import style from './SelfReflectionButton.scss';

const SelfReflectionButton = forwardRef(
  (
    {
      selected,
      children,
      mode,
      hover = false,
      onSelected = () => null,
      ...restProps
    },
    ref
  ) => (
    <div
      role="button"
      className={cx(style.container, {
        [style.hover]: hover,
        [style.positive]: mode === 'positive',
        [style.negative]: mode === 'negative',
        [style.selected]: selected,
      })}
      onClick={() => (!selected ? onSelected() : null)}
      ref={ref}
      {...restProps}
    >
      <div
        className={cx(style.indicator, {
          [style.positive]: mode === 'positive',
          [style.negative]: mode === 'negative',
        })}
      />
      <div className={style.content}>{children}</div>
    </div>
  )
);

export default SelfReflectionButton;
